import ResourceManager from "@/components/common/ResourceManager";
import { eur, fdate } from "@/lib/format";

const vehLabel = (id, lookups) => {
  const v = (lookups.vehicles || []).find((x) => x.id === id);
  return v ? `${v.brand} ${v.model} (${v.registration})` : "—";
};
const STATUS_CLS = {
  "Déclaré": "bg-blue-50 text-blue-700 border-blue-200",
  "En cours": "bg-amber-50 text-amber-700 border-amber-200",
  "Expertisé": "bg-purple-50 text-purple-700 border-purple-200",
  "Réparations": "bg-orange-50 text-orange-700 border-orange-200",
  "Clôturé": "bg-emerald-50 text-emerald-700 border-emerald-200",
};
const urlFilters = {
  statut: { label: () => "Sinistres ouverts", test: (r) => !["Clôturé", "Cloture"].includes(r.status) },
};

export default function Accidents() {
  const columns = [
    { key: "file_number", label: "N° dossier", render: (r) => <span className="font-mono text-xs">{r.file_number}</span> },
    { key: "vehicle_id", label: "Véhicule", render: (r, l) => vehLabel(r.vehicle_id, l) },
    { key: "date", label: "Date", render: (r) => fdate(r.date) },
    { key: "type", label: "Type" },
    { key: "responsibility", label: "Responsabilité" },
    { key: "amount", label: "Montant", render: (r) => eur(r.amount) },
    { key: "status", label: "Statut", render: (r) => <span className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs font-medium ${STATUS_CLS[r.status] || "bg-gray-100 text-gray-700 border-gray-300"}`}>{r.status}</span> },
  ];
  const fields = [
    { key: "vehicle_id", label: "Véhicule", type: "vehicle", full: true },
    { key: "date", label: "Date", type: "date" },
    { key: "time", label: "Heure" },
    { key: "location", label: "Lieu" },
    { key: "type", label: "Type de sinistre", type: "select", options: ["Accrochage", "Collision", "Bris de glace", "Vol", "Dommage stationnement", "Autre"] },
    { key: "responsibility", label: "Responsabilité", type: "select", options: ["Responsable", "Non responsable", "Partagée"] },
    { key: "insurer", label: "Assurance" },
    { key: "file_number", label: "N° de dossier" },
    { key: "amount", label: "Montant (€)", type: "number" },
    { key: "franchise", label: "Franchise (€)", type: "number" },
    { key: "status", label: "Statut", type: "select", options: ["Déclaré", "En cours", "Expertisé", "Réparations", "Clôturé"] },
    { key: "description", label: "Description", type: "textarea", full: true },
  ];
  return <ResourceManager title="Sinistres" subtitle="Déclaration et suivi des sinistres." resource="accidents" exportCollection="accidents" columns={columns} fields={fields} lookupsNeeded={["vehicles"]} defaultForm={{ status: "Déclaré" }} urlFilters={urlFilters} />;
}
